import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getDashboardPath } from '../../config/hospitalRoles';

/**
 * Legacy /dashboard entry — auto-redirects to role-based dashboard route.
 */
const DashboardRouter = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user) {
      const target = getDashboardPath(user);
      navigate(target + (location.search || ''), { replace: true, state: location.state });
    }
  }, [user, navigate, location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <p className="text-gray-600">Redirecting to your dashboard…</p>
    </div>
  );
};

export default DashboardRouter;
